module.exports = __webpack_public_path__ + "img/grid-srp-preview-chevy.0ef51f58.png";